import StudentComponent from "./StudentComponent";
import TeacherComponent from "./TeacherComponent";
import TeacherComponentLegacy from "./TeacherComponentLegacy";

interface ExportablesModalType {
  Student: typeof StudentComponent;
  Teacher: typeof TeacherComponent;
  TeacherLegacy: typeof TeacherComponentLegacy;
}

const ExportablesModalBase: React.FC = () => {
  throw new Error(
    "❌ Do not use <ExportablesModal /> directly. Use <ExportablesModal.Student /> or <ExportablesModal.Teacher /> instead.",
  );
};

const ExportablesModal =
  ExportablesModalBase as unknown as ExportablesModalType;

ExportablesModal.Student = StudentComponent;
ExportablesModal.Teacher = TeacherComponent;
ExportablesModal.TeacherLegacy = TeacherComponentLegacy;

export default ExportablesModal;
